import fontBig0 from './assets/font_big_0.png'
import fontBig1 from './assets/font_big_1.png'
import fontBig2 from './assets/font_big_2.png'
import fontBig3 from './assets/font_big_3.png'
import fontBig4 from './assets/font_big_4.png'
import fontBig5 from './assets/font_big_5.png'
import fontBig6 from './assets/font_big_6.png'
import fontBig7 from './assets/font_big_7.png'
import fontBig8 from './assets/font_big_8.png'
import fontBig9 from './assets/font_big_9.png'

export default {
  0: (() => {
    const image = new Image()
    image.src = fontBig0
    return image
  })(),
  1: (() => {
    const image = new Image()
    image.src = fontBig1
    return image
  })(),
  2: (() => {
    const image = new Image()
    image.src = fontBig2
    return image
  })(),
  3: (() => {
    const image = new Image()
    image.src = fontBig3
    return image
  })(),
  4: (() => {
    const image = new Image()
    image.src = fontBig4
    return image
  })(),
  5: (() => {
    const image = new Image()
    image.src = fontBig5
    return image
  })(),
  6: (() => {
    const image = new Image()
    image.src = fontBig6
    return image
  })(),
  7: (() => {
    const image = new Image()
    image.src = fontBig7
    return image
  })(),
  8: (() => {
    const image = new Image()
    image.src = fontBig8
    return image
  })(),
  9: (() => {
    const image = new Image()
    image.src = fontBig9
    return image
  })(),
}
